import {
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[rrCtrlClick]',
})
export class CtrlClickDirective implements OnInit, OnDestroy {
  @Output('rrCtrlClick') ctrlClickEvent = new EventEmitter();

  private unsubscribe: any;

  constructor(
    private readonly renderer: Renderer2,
    private readonly element: ElementRef,
  ) {}

  ngOnInit() {
    this.unsubscribe = this.renderer.listen(
      this.element.nativeElement,
      'click',
      (event) => {
        if (event.ctrlKey) {
          event.preventDefault();
          event.stopPropagation();
          // unselect accidentally selected text (browser default behaviour)
          document.getSelection().removeAllRanges();

          this.ctrlClickEvent.emit(event);
        }
      },
    );
  }

  ngOnDestroy() {
    if (!this.unsubscribe) {
      return;
    }
    this.unsubscribe();
  }
}
